import { Actions } from '@src/constants/Constants';

export interface IAlertState {
    isVisible: boolean;
    msg: string;
}

const initialState: IAlertState = {
    isVisible: false,
    msg: '',
};

export default function preloaderState(
    state: IAlertState = initialState,
    action: any,
): IAlertState {
    switch (action.type) {
        case Actions.SHOW_ALERT:
            return { ...state, isVisible: true, msg: action.payload };

        case Actions.HIDE_ALERT:
            return { ...state, isVisible: false, msg: '' };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/AlertReducer.ts